import Api from "./Api.js";
import { getBaseUrl } from "./ApiHelper.js";

const resource = "/utilities";

export default {
  bulkEmailSearch(params) {
    return Api.get(`${resource}/bulk-email`, {
      params: params,
    });
  },

  sendBulkEmails(data) {
    return Api.post(`${resource}/bulk-email`, data);
  },

  backorders(params) {
    return Api.get(`${resource}/backorders`, {
      params: params,
    });
  },

  createBackordersNotes(data) {
    return Api.post(`${resource}/backorders/notes`, data);
  },

  createZendeskTickets(data) {
    return Api.post(`zendesk/tickets`, data);
  },

  validateSkuStateRestriction(data) {
    // This is going to return a 410 so any components calling this will break (i.e., the old DorrmancyClaim slideover
    // and ReviseLineItemBySKU). That's intentional: any such components will need to be brought into the VBI world
    // before they can be used again.
    return Api.post(`${resource}/sku-state-restrictions`, data);
  },

  testStateRestrictions(data) {
    return Api.post(`${resource}/test-state-restrictions`, data, {
      baseURL: getBaseUrl("v2")
    });
  },
};
